import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import CountUp from "react-countup";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import ModalPreview from "components/Common/ModalPreview";
import {
  CHAT_TYPE_LOG_OPTION,
  COLOR_CHAT_TYPE_LOG,
  COLOR_CONTENT_TYPE_CHAT_LOG,
  COLOR_USER_TYPE_CHAT_LOG,
  CONTENT_TYPE_CHAT_LOG_OPTION,
  ENUM_CHAT_TYPE_LOG,
  USER_TYPE_CHAT_LOG_OPTION
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import avatar1 from "../../assets/images/users/ic_defaul_avatar2.png";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import CopyWrapper from "components/Common/CopyWrapper";
import { getChatLogs } from "store/chatLog/thunk";
import ModalGroupMember from "./ModalGroupMember";


registerLocale("en", en);
registerLocale("ko", ko);

const ChatLogList = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    // "sort[createdAt]": withDefault(StringParam, `desc`),
    // order_by: withDefault(StringParam, `DESC`),
    // date_version: withDefault(StringParam, ''),
    sender_nickname: withDefault(StringParam, ""),
    sender_email: withDefault(StringParam, ""),
    sender_user_type: withDefault(StringParam, ""),
    recipient_nickname: withDefault(StringParam, ""),
    recipient_email: withDefault(StringParam, ""),
    recipient_user_type: withDefault(StringParam, ""),
    chat_type: withDefault(StringParam, ""),
    sent_at_from: withDefault(
      StringParam,
      (new Date(moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss"))).toISOString()
    ),
    sent_at_to: withDefault(
      StringParam,
      (new Date(moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss"))).toISOString()
    ),
    message_type: withDefault(StringParam, ""),
  });


  const [senderNicknameSearch, setSenderNicknameSearch] = useState<string>(query?.sender_nickname || "");
  const [senderEmailSearch, setSenderEmailSearch] = useState<string>(query?.sender_email || "");
  const [senderUserTypeSearch, setSenderUserTypeSearch] = useState<any>(
    USER_TYPE_CHAT_LOG_OPTION?.find((item) => item?.value === query?.sender_user_type)
      ?.value ?? ""
  );
  const [recipientNicknameSearch, setRecipientNicknameSearch] = useState<string>(query?.recipient_nickname || "");
  const [recipientEmailSearch, setRecipientEmailSearch] = useState<string>(query?.recipient_email || "");
  const [recipientUserTypeSearch, setRecipientUserTypeSearch] = useState<any>(
    USER_TYPE_CHAT_LOG_OPTION?.find((item) => item?.value === query?.recipient_user_type)
      ?.value ?? ""
  );
  const [chatTypeSearch, setChatTypeSearch] = useState<any>(
    CHAT_TYPE_LOG_OPTION?.find((item) => item?.value === query?.chat_type)
      ?.value ?? ""
  );
  const [contentTypeSearch, setContentTypeSearch] = useState<any>(
    CONTENT_TYPE_CHAT_LOG_OPTION?.find((item) => item?.value === query?.message_type)
      ?.value ?? ""
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
  ]);
  const [sent_at_from, sent_at_to] = dateSearch;

  const [linkImage, setLinkImage] = useState<string>("");
  const [itemToChatGroup, setItemToChatGroup] = useState<any>(null);

  const selectLayoutState = (state: any) => state.ChatLog;
  const LocationLogProperties = createSelector(selectLayoutState, (state) => ({
    chatLogs: state.chatLogs,
    isChatLogLoading: state.isChatLogLoading,
    isChatLogSuccess: state.isChatLogSuccess,

    error: state.error,
  }));

  // Inside your component
  const { chatLogs, isChatLogLoading } = useSelector(
    LocationLogProperties
  );

  function loadTableData() {
    dispatch(getChatLogs(query));
  }

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      sender_nickname: senderNicknameSearch.trim() || "",
      sender_email: senderEmailSearch.trim() || "",
      sender_user_type: senderUserTypeSearch,
      recipient_nickname: recipientNicknameSearch.trim() || "",
      recipient_email: recipientEmailSearch.trim() || "",
      recipient_user_type: recipientUserTypeSearch,
      chat_type: chatTypeSearch,
      message_type: contentTypeSearch,
      sent_at_from: sent_at_from ? (new Date(moment(new Date(sent_at_from)).startOf("day").format("Y-MM-DD HH:mm:ss"))).toISOString() : "",
      sent_at_to: sent_at_to ? (new Date(moment(new Date(sent_at_to)).endOf("day").format("Y-MM-DD HH:mm:ss"))).toISOString() : "",
      //sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        sender_nickname: "",
        sender_email: "",
        sender_user_type: "",
        recipient_nickname: "",
        recipient_email: "",
        recipient_user_type: "",
        chat_type: "",
        message_type: "",
        sent_at_from: (new Date(moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss"))).toISOString(),
        sent_at_to: (new Date(moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss"))).toISOString(),
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );

    setSenderNicknameSearch("");
    setSenderEmailSearch("");
    setSenderUserTypeSearch("");
    setRecipientNicknameSearch("");
    setRecipientEmailSearch("");
    setRecipientUserTypeSearch("");
    setChatTypeSearch("");
    setContentTypeSearch("");
    setDateSearch([
      (new Date(moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss"))),
      (new Date(moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss"))),
    ]);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 45,
        thClass: "align-middle whitespace-nowrap th-border-right-1px",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 40 }} className="td-border-right-1px">
              {chatLogs?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Chat Type"),
        accessor: "chat",
        filterable: false,
        sortable: false,
        thWidth: 100,
        thClass: "text-center align-middle whitespace-nowrap th-border-right-1px",
        Cell: (cell: any) => {
          const type = cell?.value?.type;
          return (
            <div className="text-center td-border-right-1px" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_CHAT_TYPE_LOG[type] || "secondary"
                  }`}
              >
                {t(
                  CHAT_TYPE_LOG_OPTION?.find(
                    (item: any) => String(item?.value) === String(type)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Content Type"),
        accessor: "type",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "text-center align-middle whitespace-nowrap th-border-right-1px",
        Cell: (cell: any) => {
          const type = cell?.value;
          return (
            <div className="text-center td-border-right-1px" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_CONTENT_TYPE_CHAT_LOG[type] || "secondary"
                  }`}
              >
                {t(
                  CONTENT_TYPE_CHAT_LOG_OPTION?.find(
                    (item: any) => String(item?.value) === String(type)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t('Sender'),
        accessor: "Sender",
        thClass: 'align-middle  text-end',
        filterable: false,
        sortable: false,
        thWidth: 600,
        thComponent: () => (
          <table className="th-border-right-1px  chat-log-px-0 w-100">
            <thead>
              <tr>
                <th className="whitespace-nowrap text-center th-border-bottom-1px pb-2 none-sticky" colSpan={4}>
                  {t('Sender')}
                </th>
              </tr>
              <tr>
                <tr>
                  <th className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky" style={{ width: '80px' }}
                  >
                    {t('Avatar')}
                  </th>
                  <th className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer th-sticky" style={{ width: '200px' }}
                  >
                    {t('Nickname')}
                  </th>
                  <th className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky" style={{ width: '220px' }}
                  >
                    {t('Email')}
                  </th>
                  <th className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky" style={{ width: '100px' }}
                  >
                    {t('User Type')}
                  </th>
                </tr>
              </tr>
            </thead>
          </table>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original?.author;
          const avatar: any = item?.avatar?.avatarURL;
          const nickName: any = item?.nickname;
          const email: any = item?.email;
          const userType: any = item?.type;

          return (
            <div className="d-flex text-center td-border-right-1px chat-log-px-0 align-items-center">
              <div style={{ width: '80px' }}>
                <div className="w-100 text-center " style={{ minWidth: "60px" }}>
                  <div
                    style={{ width: "45px" }}
                    className="m-auto cursor-pointer"
                    onClick={() => setLinkImage((prev) => avatar)}
                  >
                    <img
                      src={avatar ?? avatar1}
                      className="rounded-circle avatar-sm"
                      alt="thumbnail"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = avatar1;
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ width: '200px', borderLeft: "1px solid #eaeaea", borderRight: "1px solid #eaeaea", }} className="div-sticky">
                {
                  nickName && (
                    <div className="cursor-pointer">
                      <CopyWrapper contentCopy={nickName}>
                        {`${nickName}`}
                      </CopyWrapper>
                    </div>
                  )
                }
              </div>
              <div style={{ width: '220px', borderRight: "1px solid #eaeaea" }}>
                {
                  email && (
                    <div className="cursor-pointer">
                      <CopyWrapper contentCopy={email}>
                        {`${email}`}
                      </CopyWrapper>
                    </div>
                  )
                }
              </div>
              <div style={{ width: '100px' }}>
                <div className="text-center" style={{ minWidth: 80 }}>
                  <span
                    className={`rounded-pill badge bg-${COLOR_USER_TYPE_CHAT_LOG[userType] || "secondary"
                      }`}
                  >
                    {t(
                      USER_TYPE_CHAT_LOG_OPTION?.find(
                        (item: any) => String(item?.value) === String(userType)
                      )?.label || ""
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        },
      },

      {
        Header: t('Recipient'),
        accessor: "receiver",
        thClass: 'align-middle text-end whitespace-nowrap',
        filterable: false,
        sortable: false,
        thWidth: 600,
        thComponent: () => (
          <table className="th-border-right-1px chat-log-px-0 w-100">
            <thead>
              <tr>
                <th className="whitespace-nowrap text-center th-border-bottom-1px pb-2 none-sticky" colSpan={4}>
                  {t('Recipient')}
                </th>
              </tr>
              <tr>
                <tr>
                  <th className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky" style={{ width: '80px' }}
                  >
                    {t('Avatar')}
                  </th>
                  <th className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky" style={{ width: '200px' }}
                  >
                    {t('Nickname')}
                  </th>
                  <th className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky" style={{ width: '220px' }}
                  >
                    {t('Email')}
                  </th>
                  <th className="whitespace-nowrap text-center pb-0 pt-2 cursor-pointer none-sticky" style={{ width: '100px' }}
                  >
                    {t('User Type')}
                  </th>
                </tr>
              </tr>
            </thead>
          </table>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          let chatType = item?.chat?.type;
          let avatar: any = item?.receiver?.avatar?.avatarURL;
          let nickName: any = item?.receiver?.nickname;
          let email: any = item?.receiver?.email;
          let userType: any = item?.receiver?.type;

          if (chatType === ENUM_CHAT_TYPE_LOG.GROUP) {
            avatar = item?.chat?.groupInfo?.thumbnailUrl;
            nickName = item?.chat?.groupInfo?.name;
            email = '-';
            userType = '';
          }

          return (
            <div className="d-flex text-center td-border-right-1px chat-log-px-0 align-items-center">
              <div style={{ width: '80px' }}>
                <div className="w-100 text-center " style={{ minWidth: "60px" }}>
                  <div
                    style={{ width: "45px" }}
                    className="m-auto cursor-pointer"
                    onClick={() => setLinkImage((prev) => avatar)}
                  >
                    <img
                      src={avatar ?? avatar1}
                      className="rounded-circle avatar-sm"
                      alt="thumbnail"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = avatar1;
                      }}
                    />
                  </div>
                </div>
              </div>
              <div style={{ width: '200px', borderLeft: "1px solid #eaeaea", borderRight: "1px solid #eaeaea", }}>
                {
                  (nickName && chatType === ENUM_CHAT_TYPE_LOG.GROUP) ? (
                    <div
                      className="cursor-pointer text-primary"
                      onClick={() => {
                        setItemToChatGroup(item?.chat)
                      }}
                    >
                      {`${nickName}`}
                    </div>
                  ) : (
                    <div className="cursor-pointer">
                      <CopyWrapper contentCopy={nickName}>
                        {`${nickName}`}
                      </CopyWrapper>
                    </div>
                  )
                }
              </div>
              <div style={{ width: '220px', borderRight: "1px solid #eaeaea" }}>
                {
                  email && (
                    <div className="cursor-pointer">
                      <CopyWrapper contentCopy={email}>
                        {`${email}`}
                      </CopyWrapper>
                    </div>
                  )
                }
              </div>
              <div style={{ width: '100px' }}>
                {
                  userType ? (
                    <div className="text-center" style={{ minWidth: 80 }}>
                      <span
                        className={`rounded-pill badge bg-${COLOR_USER_TYPE_CHAT_LOG[userType] || "secondary"
                          }`}
                      >
                        {t(
                          USER_TYPE_CHAT_LOG_OPTION?.find(
                            (item: any) => String(item?.value) === String(userType)
                          )?.label || ""
                        )}
                      </span>
                    </div>
                  ) : '-'
                }
              </div>
            </div>
          );
        },
      },

      {
        Header: t("Created at"),
        accessor: "createdAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, chatLogs?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const onCloseGroupChat = () => {
    setItemToChatGroup(null);
  }

  useEffect(() => {
    document.title = `${t("Chat Log")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);


  const onCloseImageClick = () => {
    setLinkImage((_prev) => "");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Chat Log")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={chatLogs?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={4}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Sender Nickname")}`}
                          isShow={!!senderNicknameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Sender Nickname")}...`}
                            value={senderNicknameSearch}
                            onChange={(e) => setSenderNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={4}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Sender Email")}`}
                          isShow={!!senderEmailSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Sender Email")}...`}
                            value={senderEmailSearch}
                            onChange={(e) => setSenderEmailSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={4}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Sender User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type-user"
                            dataList={USER_TYPE_CHAT_LOG_OPTION || []}
                            placeholder={`${t("Sender User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={senderUserTypeSearch}
                            onChangeSelect={(e: any) =>
                              setSenderUserTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_TYPE_CHAT_LOG}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={4}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Recipient Nickname")}`}
                          isShow={!!recipientNicknameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Recipient Nickname")}...`}
                            value={recipientNicknameSearch}
                            onChange={(e) => setRecipientNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={4}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Recipient Email")}`}
                          isShow={!!recipientEmailSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Recipient Email")}...`}
                            value={recipientEmailSearch}
                            onChange={(e) => setRecipientEmailSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={4}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Recipient User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type-user"
                            dataList={USER_TYPE_CHAT_LOG_OPTION || []}
                            placeholder={`${t("Recipient User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={recipientUserTypeSearch}
                            onChangeSelect={(e: any) =>
                              setRecipientUserTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_TYPE_CHAT_LOG}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={4}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Chat Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type-user"
                            dataList={CHAT_TYPE_LOG_OPTION || []}
                            placeholder={`${t("Chat Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={chatTypeSearch}
                            onChangeSelect={(e: any) =>
                              setChatTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_CHAT_TYPE_LOG}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={4}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Content Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type"
                            dataList={CONTENT_TYPE_CHAT_LOG_OPTION || []}
                            placeholder={`${t("Content Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={contentTypeSearch}
                            onChangeSelect={(e: any) =>
                              setContentTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_CONTENT_TYPE_CHAT_LOG}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={4}
                        xl={4}
                        xxl={4}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!sent_at_from || !!sent_at_to}
                        >
                          <DatePickerCustom
                            startDate={sent_at_from || null}
                            endDate={sent_at_to || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={12}
                        lg={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-chat-log-v2"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={
                        chatLogs?.messages?.length ? chatLogs?.messages : []
                      }
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={chatLogs?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(chatLogs?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isChatLogLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage}
          url={linkImage}
          onClose={() => onCloseImageClick()}
        />

        {itemToChatGroup && (
          <ModalGroupMember
            isOpen={true}
            item={itemToChatGroup}
            setLinkImage={setLinkImage}
            onClose={onCloseGroupChat}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default ChatLogList;
